import { render, staticRenderFns } from "./index.vue?vue&type=template&id=52e0c982&lang=pug"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspaces/wuwow-junior-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('52e0c982')) {
      api.createRecord('52e0c982', component.options)
    } else {
      api.reload('52e0c982', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=52e0c982&lang=pug", function () {
      api.rerender('52e0c982', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/consultant/vipRecords/performance/modal/addStudentPerformance/index.vue"
export default component.exports